

// 视频最小时长 15s
export const MIN_VIDEO_DURATION = 15 * 1000 * 1000
// 视频最大时长 15分钟
export const MAX_VIDEO_DURATION = 15 * 60 * 1000 * 1000

export const formatTime = (microseconds: number): string => {
    const totalSeconds = Math.floor(microseconds / 1000 / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const remainingSeconds = totalSeconds % 60

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
}


// 只有小时和分钟
export const formatTimeOnlyHoursAndMinutes = (timeInMicroseconds: number): string => {
    const minutes = Math.floor(timeInMicroseconds / 60 / 1000 / 1000)
    const seconds = Math.floor((timeInMicroseconds % (60 * 1000 * 1000)) / 1000 / 1000)
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}